<template >
  <div class="g-wrapper g-vertical-block">
    <div class="g-main-wrapper g-vertical-block main-content">
      <Tabs :value="$route.name" @on-click="changeRouter">
        <TabPane name="data-report-list" label="数据上报任务"></TabPane>
        <TabPane name="data-report-log" label="日志" v-if="logAuth"></TabPane>
        <TabPane
          name="data-report-form"
          :label="`${$route.query.ruleId ? '编辑' : '新建'}上报任务`"
          v-if="$route.name === 'data-report-form'"
        ></TabPane>
      </Tabs>

      <keep-alive :max="10">
        <router-view />
      </keep-alive>
    </div>
  </div>
</template>
<script>
export default {
  name: 'datareportcontrollist',
  data() {
    return {
      currentRoute: 'data-report-list'
    }
  },
  computed: {
    logAuth() {
      return this.$store.state.accessAuth?.includes('M21038')
    }
  },
  methods: {
    changeRouter(name) {
      this.$router.push({ name })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
